export default __webpack_public_path__ + "static/media/Icon ionic-ios-lock.98e232c0.svg";